<form [formGroup]="paymentForm" (submit)="createPayment()">
    <modal-panel
        id="payment-form-modal"
        class="filter-panel"
        [title]="serviceData?.recordLocator ? 'Create New Payment for ' + serviceData?.recordLocator : 'Create New Payment'"
        (close)="closePaymentForm();"
        [showConfirmDialog]="true"
        >
        <div id="payment-form-modal-content" class="filter__fields two-col-grid">
            <div class="one">
                <mat-form-field>
                    <mat-label>Amount</mat-label>
                    <input matInput placeholder="Amount" value="" formControlName="amount" type="number" step="1" (keypress)="checkInputAmount($event)">
                    @if(paymentForm.controls['amount'].value){
                        <button 
                            id="payment-form-modal-amount-clear-button"
                            matSuffix mat-icon-button
                            type="button"
                            (click)="clearFields('amount')">
                                <mat-icon>close</mat-icon>
                        </button>
                    }
                </mat-form-field>

                @let payTypeList = payTypeList$ | async;
                <mat-form-field>
                    <mat-label>Pay Type</mat-label>
                    <mat-select formControlName="payType">
                        @for (payType of payTypeList?.items; track payType?.id) {
                            <mat-option [value]="payType?.id">{{payType?.payTypeName}}</mat-option>
                        } 
                    </mat-select>
                    @if(paymentForm.controls['payType'].value && !paymentForm.controls['payType'].disabled ){
                        <button 
                            id="payment-form-modal-amount-pay-type-button"
                            matSuffix mat-icon-button
                            type="button"
                            (click)="clearFields('payType')">
                                <mat-icon>close</mat-icon>
                        </button>
                    }
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Bank</mat-label>
                    <input type="text" matInput formControlName="bank" [matAutocomplete]="bankAuto">
                    <mat-autocomplete #bankAuto="matAutocomplete" [displayWith]="displayWithBank">
                        @for (bank of filteredBank$ | async; track bank?.id) {
                            <mat-option [value]="bank">{{bank?.name}}</mat-option>
                        }    
                    </mat-autocomplete>
                    @if(paymentForm.controls['bank'].value){
                        <button 
                            id="payment-form-modal-bank-clear-button"
                            matSuffix mat-icon-button
                            type="button"
                            (click)="clearFields('bank')">
                                <mat-icon>close</mat-icon>
                        </button>
                    }
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Branch</mat-label>
                    <input type="text" matInput formControlName="branch" [matAutocomplete]="branchAuto">
                    <mat-autocomplete #branchAuto="matAutocomplete" [displayWith]="displayWithBranch">
                        @for (branch of filteredBranch$ | async; track branch?.id) {
                            <mat-option [value]="branch">{{branch?.name}}</mat-option>
                        }
                    </mat-autocomplete>
                    @if(paymentForm.controls['branch'].value){
                        <button 
                            id="payment-form-modal-branch-clear-button"
                            matSuffix mat-icon-button
                            type="button"
                            (click)="clearFields('branch')">
                                <mat-icon>close</mat-icon>
                        </button>
                    }
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Pay Method</mat-label>
                    <input type="text" matInput formControlName="payMethod" [matAutocomplete]="payMethodAuto">
                    <mat-autocomplete #payMethodAuto="matAutocomplete" [displayWith]="displayWithPayMethod">
                        @for (payMethod of filteredPayMethod$ | async; track payMethod?.id) {
                            <mat-option [value]="payMethod">{{payMethod?.paymethodName}}</mat-option>
                        }
                    </mat-autocomplete>
                    @if(paymentForm.controls['payMethod'].value){
                        <button 
                            id="payment-form-modal-pay-method-clear-button"
                            matSuffix mat-icon-button
                            type="button"
                            (click)="clearFields('payMethod')">
                                <mat-icon>close</mat-icon>
                        </button>
                    }
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Profile Type</mat-label>
                    <input type="text" matInput formControlName="profileType" [matAutocomplete]="profileTypeAuto">
                    <mat-autocomplete #profileTypeAuto="matAutocomplete" [displayWith]="displayWithProfileType" (optionSelected)="profileTypeSelected()">
                        @for (profileType of filteredProfileType$ | async; track profileType?.id) {
                            <mat-option (click)="setAutocompleteMode(profileType)" [value]="profileType">{{profileType?.profileTypeName}}</mat-option>
                        }
                    </mat-autocomplete>
                    @if(paymentForm.controls['profileType'].value){
                        <button 
                            id="payment-form-modal-profile-type-clear-button"
                            matSuffix mat-icon-button
                            type="button"
                            (click)="clearFields('profileType')">
                                <mat-icon>close</mat-icon>
                        </button>
                    }
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Submit To</mat-label>
                    <input type="text" matInput formControlName="submitTo" [matAutocomplete]="submitToAuto">
                    <mat-autocomplete #submitToAuto="matAutocomplete" [displayWith]="displayWithSubmitTo">
                        @for (submitTo of filteredSubmitTo$ | async; track submitTo?.id) {
                            <mat-option [value]="submitTo">{{submitTo?.submitToLink}}</mat-option>
                        }
                    </mat-autocomplete>
                    @if(paymentForm.controls['submitTo'].value){
                        <button 
                            id="payment-form-modal-submit-to-clear-button"
                            matSuffix mat-icon-button
                            type="button"
                            (click)="clearFields('submitTo')">
                                <mat-icon>close</mat-icon>
                        </button>
                    }
                </mat-form-field>
            </div>
            <div class="two">
                <mat-form-field>
                    <mat-label>Payment Date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="paymentDate" [max]="maxDate">
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-datepicker #picker></mat-datepicker>
                    @if(paymentForm.controls['paymentDate'].value){
                        <button 
                            id="payment-form-modal-payment-date-clear-button"
                            matSuffix mat-icon-button
                            type="button"
                            (click)="clearFields('paymentDate')">
                                <mat-icon>close</mat-icon>
                        </button>
                    } @else {
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    }
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Fms Invoice Number</mat-label>
                    <input matInput placeholder="Fms Invoice Number" value="" formControlName="invoiceReference" type="number" step="1" min="0" (keypress)="checkInput($event)">
                    @if(paymentForm.controls['invoiceReference'].value && paymentForm.controls['invoiceReference'].enabled){
                        <button 
                            id="payment-form-modal-invoice-reference-clear-button"
                            matSuffix mat-icon-button
                            type="button"
                            (click)="clearFields('invoiceReference')">
                                <mat-icon>close</mat-icon>
                        </button>
                    }
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Fms Booking Number</mat-label>
                    <input matInput placeholder="Fms Booking Number" value="" formControlName="adxBookingId" type="number" step="1" min="0" (keypress)="checkInput($event)">
                    @if(paymentForm.controls['adxBookingId'].value && paymentForm.controls['adxBookingId'].enabled){
                        <button 
                            id="payment-form-modal-invoice-reference-clear-button"
                            matSuffix mat-icon-button
                            type="button"
                            (click)="clearFields('adxBookingId')">
                                <mat-icon>close</mat-icon>
                        </button>
                    }
                </mat-form-field>


                <mat-form-field>
                    <mat-label>Remarks</mat-label>
                    <textarea id="financial-alerts-description-input" matInput formControlName="remarks" style="height: 24px;"></textarea>
                    @if(paymentForm.controls['remarks'].value){
                        <button 
                            id="payment-form-modal-remarks-clear-button"
                            matSuffix mat-icon-button
                            type="button"
                            (click)="clearFields('remarks')">
                                <mat-icon>close</mat-icon>
                        </button>
                    }
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Payment Reference Number</mat-label>
                    <input matInput [placeholder]=" isCcNumber ? 'Last four digits' : 'Payment Reference Number'" value="" formControlName="number">
                    @if(paymentForm.controls['number'].value){
                        <button 
                            id="payment-form-modal-number-clear-button"
                            matSuffix mat-icon-button
                            type="button"
                            (click)="clearFields('number')">
                                <mat-icon>close</mat-icon>
                        </button>
                    }
                    @if (paymentForm.controls['number'].hasError('pattern')) {
                        <mat-error>Provide four numbers</mat-error>
                    }
                </mat-form-field>

                <profile-autocomplete [autocompleteMode]="autocompleteMode" [dataSourceId]="stepperInformation()?.dataSourceId || serviceData?.dataSourceId" formControlName="name"></profile-autocomplete>

                <mat-form-field>
                    <mat-label>Currency</mat-label>
                    <input type="text" matInput formControlName="currency" [matAutocomplete]="currencyAuto">
                    <mat-autocomplete #currencyAuto="matAutocomplete" [displayWith]="displayWithCurrencyList">
                        @for (currency of filteredCurrency$ | async; track currency?.id) {
                            <mat-option [value]="currency">
                                {{currency?.currencyName}} {{currency?.symbol ? '('+currency?.symbol+')' : ''}}
                            </mat-option>
                        }
                    </mat-autocomplete>
                    @if(paymentForm.controls['currency'].value){
                        <button 
                            id="payment-form-modal-currency-clear-button"
                            matSuffix mat-icon-button
                            type="button"
                            (click)="clearFields('currency'); $event.stopPropagation()">
                                <mat-icon>close</mat-icon>
                        </button>
                    }
                </mat-form-field>
            </div>
        </div>

        <ng-container id="payment-form-modal-footer-container" modalPanelFooter>
            <div class="modal-footer">
                <button id="payment-form-modal-button-clear-all" mat-stroked-button color="primary" type="button"  [matMenuTriggerFor]="confirmClearAll">
                    <mat-icon id="payment-form-modal-icon-clear-all-filter-button-icon">delete_outline</mat-icon>
                    Clear All
                </button>
                <mat-menu #confirmClearAll="matMenu" yPosition="above" xPosition="after">
                    <p style="text-align: center;">Are you sure you want to clear all fields?</p>
                    <div class="items-space-between">
                        <button color="warn" mat-raised-button (click)="clearFields()">Yes</button>
                        <button color="primary" mat-raised-button>No</button>
                    </div>
                </mat-menu>

                <button id="payment-form-modal-submit-button" mat-raised-button color="primary" type="submit" [disabled]="paymentForm.invalid || isLoadingSpinner">
                    <mat-spinner
                        id="delete-vcc-dialog-spinner"
                        color="accent"
                        *ngIf="isLoadingSpinner"
                        diameter="30">
                    </mat-spinner>
                    <span id="delete-service-dialog-create-span" *ngIf="!isLoadingSpinner">Create</span>
                </button>
            </div>
        </ng-container>
    </modal-panel>
</form>